import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import { useMediaQuery, useTheme } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLeft from "./AuthLeft";
import { ResetPassword } from "../../services/auth";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

export default function Login() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  //   const path = usercalls();

  const [load, setLoad] = useState(false);


  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const location = useLocation();

  const [errors, setErrors] = useState({
    password: "",
    confirmpassword: "",
  });
  const [allPassword, setAllPassword] = useState({
    password: "",
    confirmpassword: "",
  });
  const [token, setToken] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramValue = queryParams.get("token");
    setToken(paramValue);
  });
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setAllPassword({ ...allPassword, [name]: value });
  };
  const validateFocus = (e) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;

    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        errorMessage = "Email is required";
        isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }

    // Handle password validation
    if (fieldName === "password") {
      if (value === "" || value === undefined) {
        errorMessage = "Password is required";
        isValid = false;
      } else if (!passwordRegex.test(value)) {
        errorMessage =
          "Password must contain at least 6 characters, one uppercase letter, one special character, and one number";
        isValid = false;
      }
    } else {
      if (value === "" || value === undefined) {
        errorMessage = "confirmpassword is required";
        isValid = false;
      } else if (allPassword.password != value) {
        errorMessage = "confirm password does not match";
        isValid = false;
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate password
    if (!allPassword.password) {
      formErrors.password = "password is required";
      isValid = false;
    } else if (!allPassword.confirmpassword) {
      formErrors.confirmpassword = "confirmpassword is required";
      isValid = false;
    } else if (allPassword.password.length < 6) {
      formErrors.password = "password must be at least 8 characters long";
      isValid = false;
    } else if (!/^[A-Z]/.test(allPassword.password)) {
      formErrors.password = "password must start with a capital letter";
      isValid = false;
    } else if (allPassword.confirmpassword.length < 6) {
      formErrors.confirmpassword =
        "password must be at least 8 characters long";
      isValid = false;
    } else if (!/^[A-Z]/.test(allPassword.confirmpassword)) {
      formErrors.confirmpassword = "password must start with a capital letter";
      isValid = false;
    } else if (allPassword.password != allPassword.confirmpassword) {
      formErrors.confirmpassword = "confirm password does not match";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const data = {
        password: allPassword.password,
        confirmpassword: allPassword.confirmpassword,
        token: token,
      };

      const response = await ResetPassword(data);

      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setLoad(false);
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else {
        toast.error(response?.data?.message);

        setLoad(false);
      }
    }
  };

  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
      <ToastContainer />
      <div className="register">
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "flex-start", pt: 0 }}
          className={!md ? "medium" : ""}
        >
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
            sx={{ pt: 0 }}
            style={{ paddingTop: "0px" }}
          >
            <AuthLeft />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "600px",
                margin: "0 auto",
              }}
            >
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Box
                  sx={{
                    my: md && 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <h2 className="c-accout text-center">Reset Password</h2>
                  <p> Enter you new password</p>

                  <Box sx={{ mt: 1, width: "100%" }}>
                    <div className="input-common mt-20">
                      <label>New Password</label>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={allPassword.password}
                          placeholder="Enter your password"
                          // onChange={(e) => {
                          //   setPassword(e.target.value);
                          // }}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.password}
                          name="password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                className="eye-icon"
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          // label="Password"
                        />
                      </FormControl>
                      <span
                        style={{
                          color: "#d32f2f",
                          fontSize: 13,
                          fontWeight: "bold",
                        }}
                      >
                        {errors.password}
                      </span>
                    </div>

                    <div className="input-common mt-20">
                      <label>Confirm Password</label>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          // onChange={(e) => {
                          //   setPassword(e.target.value);
                          // }}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.confirmpassword}
                          value={allPassword.confirmpassword}
                          name="confirmpassword"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                className="eye-icon"
                                aria-label={
                                  showConfirmPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowConfirmPassword}
                                edge="end"
                              >
                                {showConfirmPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <span
                        style={{
                          color: "#d32f2f",
                          fontSize: 13,
                          fontWeight: "bold",
                        }}
                      >
                        {errors.confirmpassword}
                      </span>
                    </div>

                    <div className="common-btn text-center">
                      {load ? (
                        <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          // onClick={() => {
                          //   navigate("/trade");
                          // }}
                          onClick={handleResetSubmit}
                        >
                          Reset
                        </Button>
                      )}
                    </div>

                    <div className="text-center accnt-sign mt-50">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
